import React, { Component } from "react";
import { Form, InputNumber, Modal, Input, Button } from "antd";

class ModalDeal extends Component {
  state = {
    checkButtonSend: false,
    finalPrice: null,
    loadingButton: false,
    notes: null,
  };

  // ************************* Function Change Data *************************//
  checkButtonSend() {
    const { finalPrice, notes } = this.state;
    if (finalPrice && notes) {
      this.setState({ checkButtonSend: true });
    } else {
      this.setState({ checkButtonSend: false });
    }
  }

  changeFinalPrice(price) {
    this.setState({ finalPrice: price }, () => this.checkButtonSend());
  }

  changeNotes(e) {
    this.setState({ notes: e.target.value }, () => this.checkButtonSend());
  }

  emptyState() {
    this.setState({ notes: null, finalPrice: null, checkButtonSend: false });
  }

  // ************************* Function Send Button *************************//
  async sendDealButton(type) {
    const { finalPrice, notes } = this.state;
    const data = {
      notes,
      deal: true,
      finalPrice,
    };
    this.setState({ loadingButton: true });
    if (type === "Trade In")
      await this.props.sendButton({
        deal: true,
        notes: null,
        noDealNotes: null,
      });
    else if (type === "New Car") await this.props.sendButton(data);
    this.emptyState();
    this.setState({ loadingButton: false });
    this.props.visibleModal("Deal", false);
  }

  // ************************* Function Sub Component *************************//
  dealTradeIn() {
    return (
      <Modal
        footer={[null]}
        visible={this.props.visible}
        onCancel={() => this.props.visibleModal("Deal", false)}
      >
        <span className="ant-form-text form-text-mod">
          Apakah data yang akan anda kirim Sudah dipastikan benar?
        </span>
        <br />
        <Button
          block
          loading={this.state.loadingButton}
          size="large"
          style={{ marginTop: 20 }}
          type="primary"
          onClick={() => this.sendDealButton("Trade In")}
        >
          KIRIM
        </Button>
        <br />
        <Button
          block
          size="large"
          style={{ marginTop: 15 }}
          onClick={() => this.props.visibleModal("Deal", false)}
        >
          Kembali
        </Button>
      </Modal>
    );
  }

  dealNewCar(hargaFinal) {
    return (
      <Modal
        footer={[null]}
        title="Harga Final"
        visible={this.props.visible}
        onCancel={() => {
          this.props.visibleModal("Deal", false), this.emptyState();
        }}
      >
        {/* Form Masukkan Nominal */}
        <Form.Item>
          <div style={{ marginBottom: 10 }}>
            <span>Masukkan Nominal</span>
            <span style={{ float: "right" }}>
              Harga Final : {this.props.formatRupiah(hargaFinal)}
            </span>
          </div>

          <InputNumber
            formatter={value =>
              `Rp. ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={value => value.replace(/Rp.\s?|(,*)/g, "")}
            size="large"
            style={{ width: "100%", marginBottom: 10 }}
            value={this.state.finalPrice}
            onChange={v => this.changeFinalPrice(v)}
          />
        </Form.Item>
        {/* End Form Masukkan Nominal */}

        {/* Form Notes*/}
        <Form.Item label="Notes">
          <Input.TextArea
            rows={4}
            value={this.state.notes}
            onChange={v => this.changeNotes(v)}
          />
        </Form.Item>
        {/* End Form Notes*/}

        {/* Button Send*/}
        <Button
          block
          disabled={this.state.checkButtonSend ? false : true}
          loading={this.state.loadingButton}
          size="large"
          type="primary"
          onClick={() => this.sendDealButton("New Car")}
        >
          KIRIM
        </Button>
        {/* End Button Send*/}
      </Modal>
    );
  }

  render() {
    const { approvalType, hargaMobil } = this.props;
    if (approvalType === "Trade In") return this.dealTradeIn();
    else if (approvalType === "New Car") return this.dealNewCar(hargaMobil);
    else return null;
  }
}

export default ModalDeal;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/Component/Modal/ModalDeal.js